import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { mergeTailwindClasses } from '@pflegia/util/functions/style/merge-tailwind-classes';

import { Badge } from '../badge/Badge.component';

export interface InitiativeBadgeProps {
  className?: string;
}

export const InitiativeBadge: React.FC<InitiativeBadgeProps> = ({ className }) => {
  const { t } = useTranslation('job', { keyPrefix: 'positionCard' });

  return <Badge className={mergeTailwindClasses('border-icon-primary text-primary w-fit border px-3', className)}>{t('initiative')}</Badge>;
};

export default InitiativeBadge;
